export default "__VITE_ASSET__B71yXgRy__"